import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Constants } from 'src/shared/utilities/constants.util';
import { RouteUtil } from 'src/shared/utilities/route.util';
import { ShiftRecord } from 'src/shared/models/shift-record.model';
import { WorkflowPage } from 'src/shared/models/workflow-page.model';
import { Client } from 'src/shared/models/client.model';

@Injectable()
export class WorkflowPageComponent {
    router: Router;
    shiftRecord: ShiftRecord;
    client: Client;

    constructor(_router: Router) { 
        this.router = _router;
    }

    initialize(page: WorkflowPage, initializeConfiguration: Function) {
        if (!page || !page.shiftRecord || !page.shiftRecord.costCenter) {
            return;
        }      
        
        this.shiftRecord = page.shiftRecord;
        this.client = page.client;

        if (initializeConfiguration) {
            initializeConfiguration();
        }
        else {
            let plannerRoute = RouteUtil.getRouteByPage(Constants.Planner);

            this.router.navigate([plannerRoute + '?costCenterId=' + this.shiftRecord.costCenterId ]);
        }  
    }  
}


